import {Component, Input} from '@angular/core';
import {Proposal} from '../../../model/proposal/proposal';

@Component({
    selector: 'app-insurance-contract-detail-risk-info',
    templateUrl: './insurance-contract-detail-risk-info.component.html',
    standalone: false
})
export class InsuranceContractDetailRiskInfoComponent {

  @Input() proposal: Proposal;

}
